
//正式服
 export const host="https://oper.gzbqdj.com/stage-api/";
 export const loginHost="https://oper.gzbqdj.com/stage-api/";
 export const fileUrl="https://cdn.gzbqdj.com/";

//测试服
// export const host="http://192.168.4.101:32674/stage-api/";
// export const loginHost="http://192.168.4.101:30879/login-api/";
// export const fileUrl="https://cdn.gzbqdj.com/";
//  export const host="http://192.168.2.179:8160/";
// export const fileUrl="https://cdn.gzbqdj.com/";